import { Fragment, useId } from "react";

import type { PathParamsBase, QueryParamsBase } from "@mpa/toolbox/endpoint/Endpoint";
import type Route from "@mpa/toolbox/navigation/Route";

import { useLocationPathname } from "./location";
import { useRouteSwitch } from "./RouteSwitchContext";
import { routeViewConfig } from "./RouteViewConfig";

type RouteViewProps<PathParams extends PathParamsBase, QueryParams extends QueryParamsBase> = {
    route: Route<PathParams, QueryParams>;
    component: React.ComponentType;
};

export default function RouteView<
    PathParams extends PathParamsBase,
    QueryParams extends QueryParamsBase,
>(props: RouteViewProps<PathParams, QueryParams>) {
    const Component = props.component;
    const pathname = useLocationPathname();
    const routeSwitch = useRouteSwitch();
    const routeSwitchId = useId();
    if (!props.route.matches(pathname)) return null;
    if (routeSwitch && !routeSwitch.register(routeSwitchId)) return null;
    const Wrapper = routeViewConfig.wrapper ?? Fragment;
    return (
        <Wrapper>
            <Component />
        </Wrapper>
    );
}
